/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Box, Flex, Button } from 'rebass';

import { H2, H3, P } from '../../components/Text';
import { Layout } from '../../layouts/Layout';
import { useTranslation } from '../../i18n/TranslationContext';

const Section: React.FC = ({ children }) => (
  <Box sx={{ my: [4, 6], display: 'flex', flexDirection: ['column', 'row'] }}>
    {children}
  </Box>
);

const volunteerURL = 'http://bit.ly/Interaction21Volunteer';

const GetInvolvedPage = () => {
  const t = useTranslation();

  return (
    <Layout title={t('get_involved_heading')}>
      <Box
        sx={{
          height: 426,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <H2 sx={{ mb: [3, 4], textAlign: 'center', maxWidth: 700 }}>
          Collectivement, nous pouvons faire une différence en ces temps
          périlleux.
        </H2>
      </Box>
      {/* Volunteer section  */}
      <Section>
        <H3 sx={{ flex: 2 }}>Devenez bénévole</H3>
        <Box sx={{ flex: 3, display: 'flex', flexDirection: 'column' }}>
          <P>
            Êtes-vous intéressé à être dans le feu de l'action avec une équipe
            de gens dévoués? Si c'est le cas, nous voulons vous entendre!
            Veuillez remplir notre{' '}
            <a
              href={volunteerURL}
              target="_blank"
              sx={{ variant: 'variants.link' }}
            >
              formulaire de demande de bénévole
            </a>{' '}
            et une personne de notre équipe vous contactera.
          </P>
          <Flex>
            <Button
              as="a"
              href={volunteerURL}
              target="_blank"
              sx={{
                display: 'flex',
                alignItems: 'center',
                maxWidth: ['100%', 'auto'],
                mt: 3,
              }}
            >
              Devenez bénévole ↗
            </Button>
          </Flex>
        </Box>
      </Section>
      {/* Propose a talk section  */}
      <Section>
        <H3 sx={{ flex: 2 }}>Proposer une idée</H3>
        <Box sx={{ flex: 3, display: 'flex', flexDirection: 'column' }}>
          <P sx={{ mb: [3, null] }}>
            Vous cherchez à partager vos idées avec notre communauté? Peut-être
            avez-vous une perspective nouvelle et inspirante qui correspond
            parfaitement au thème de notre conférence?
          </P>
          <Flex>
            <Button
              as="a"
              href="/call-for-proposals"
              sx={{
                display: 'flex',
                alignItems: 'center',
                maxWidth: ['100%', 'auto'],
                mt: 3,
              }}
            >
              Soumettre une idée
            </Button>
          </Flex>
        </Box>
      </Section>
      {/* Sponsor section  */}
      <Section>
        <H3 sx={{ flex: 2 }}>Devenez commanditaire</H3>
        <P sx={{ flex: 3 }}>
          La Semaine Interaction est possible grâce à nos incroyables
          commanditaires qui nous supportent année après année. Si un
          partenariat vous intéresse, veuillez nous contacter au{' '}
          <a
            href="mailto:sponsorship@ixda.org"
            sx={{ variant: 'variants.link' }}
          >
            sponsorship@ixda.org
          </a>
          .
        </P>
        {/* <P>
          Join us in advancing the overall interaction design practice worldwide 
          and takes a look at our <a sx={{ variant: 'variants.link' }}>sponsorship deck</a> - there are options for everyone!
        </P>
        <Button
          as="a"
          href="#"
          sx={{
            display: 'flex',
            alignItems: 'center',
            height: '48px',
            textAlign: 'left',
            maxWidth: ['100%', '300px'],
            cursor: 'pointer',
            mt: 3
          }}
        >
          Become a sponsor
        </Button> */}
      </Section>
    </Layout>
  );
};

export default GetInvolvedPage;
